/* eslint-disable camelcase */
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';
import { privateFetcher } from 'services/appFetcher.services';

interface CollectionAddressDTO {
  location_type?: string;
  country?: string;
  region?: string;
  state_or_province?: string;
  city?: string;
  postal_code?: string;
  line1?: string;
  line2?: string;
  email?: string[];
  phone?: string[];
  company?: string;
  tax_id?: string;
}

interface BookReturnDTO {
  pudo_location: {
    carrier: {
      carrier_id: string;
      carrier_references: string[];
    };
    address: CollectionAddressDTO;
    pudo_location_id: string;
  };
  shipment: {
    id: number;
    shipment_uuid: string;
  };
  return: {
    return_uuid: string;
    return_status: string;
    booking_count: number;
  };
}

export const bookReturn = async (
  orgId: number,
  params: BookReturnDTO,
): Promise<any> => {
  const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v2/ptp/return-booking/${orgId}/`;

  try {
    await privateFetcher.post(url, params);
  } catch (error) {
    throw new APIError(error.message, error);
  }
};
